import { db, ensurePrimaryPlayer, nowIso } from '@/modules/db'
import type { Player } from '@/types/player'
import { useLiveQuery } from 'dexie-react-hooks'
import { useCallback, useEffect } from 'react'

export function usePlayer() {
  const player = useLiveQuery(async () => db.players.orderBy('createdAt').first(), [])

  useEffect(() => {
    if (player !== null && player !== undefined) return
    void ensurePrimaryPlayer()
  }, [player])

  const updatePlayer = useCallback(async (updates: Partial<Player>) => {
    const existing = await db.players.orderBy('createdAt').first()
    if (!existing) {
      const created = await ensurePrimaryPlayer()
      await db.players.update(created.id, { ...updates, updatedAt: nowIso() })
      return
    }

    await db.players.update(existing.id, {
      ...updates,
      updatedAt: nowIso(),
    })
  }, [])

  return {
    player: player ?? null,
    isLoading: player === undefined,
    updatePlayer,
  }
}
